import styled from '@emotion/styled';

const WorldName = styled('h4')({
  marginBottom: 8,
  textAlign: 'center',
});

export default WorldName;
